import React, { useEffect, useState } from "react";

const noticeStyle: React.CSSProperties = {
  margin: "16px 24px 0",
  padding: "12px 16px",
  borderRadius: "12px",
  border: "1px solid var(--border)",
  background: "var(--surface-alt)",
  color: "var(--text-secondary)",
  fontSize: "13px",
  lineHeight: 1.5,
};

const NotificationPermissionNotice = () => {
  const [permission, setPermission] =
    useState<NotificationPermission | null>(null);

  useEffect(() => {
    if (!("Notification" in window)) return;

    setPermission(Notification.permission);
  }, []);

  if (permission !== "denied") {
    return null;
  }

  return (
    <div style={noticeStyle}>
      <strong style={{ color: "var(--text-primary)" }}>
        Las notificaciones están bloqueadas en este navegador.
      </strong>{" "}
      Activá el permiso desde la configuración del sitio para recibir alertas
      de nuevos envíos.
    </div>
  );
};

export default NotificationPermissionNotice;